import SectionHead from '../section/SectionHead.react'

class About extends React.Component {

    render() {
        var self    = this;
        var content = this.props.content;

        return (
            <section
                className='section about'
                id='about'>

                <SectionHead
                    title={content.header.title}
                    subtitle={content.header.subtitle} />

                <div className='row row__100'>

                    { content.details.map(function(about, i) {
                        return (
                            <div
                                className='about__content'
                                key={'about_'+i}>

                                <h3>{about.title}</h3>
                                <p>{about.content}</p>
                            </div>
                        );
                    })}

                    <div style={{ 'clear' : 'both' }} />
                </div>
            </section>
        );
    }
}

export default About;



// WEBPACK FOOTER //
// ./ui_src/app/components/about/About.react.jsx